import { createContext, useContext } from 'react';

export const ExecutionsContext = createContext();

export const useExecutionsContext = () => useContext(ExecutionsContext);
